import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Input, Button, Icon } from 'loyal-react'

var timeout;
const EmailBox = ({
  handleChange,
  handleBack,
  handleSendPassword,
  handleContinueEmailConfirm,
  handleValidateConfirmEmail,
  isLookingUpUsername,
  isHidden,
  isLoading,
  email,
  isValidConfirmEmail,
  onboardingUser,
  isEnableSend,
  timeLeft,
  error,
  ...rest
}) => {
  const handleContinueEmailConfirmAndFocus = (handleContinueEmailConfirm) => {
    if (document.querySelector('.close-accessibility-message')) {
      document.querySelector('.close-accessibility-message').focus()
    } else {
      document.getElementById('image-link').focus()
    }
    handleContinueEmailConfirm()
  }

  const debounce = () => {
    clearTimeout(timeout);
    timeout = setTimeout(handleValidateConfirmEmail, 1000);
  }

  return (
    <>
      <div id="box-temporary-password" className={`box-login box-first-access row pb-4 ${isHidden && 'd-none'}`}>
        <div className="col-12 col-md-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5">
          <div className="row">
            <div className="col-12 mb-2">
              <p className="txt-body-sm">
                <a
                  href="#"
                  className="txt-body-sm pointer d-block"
                  aria-label="Voltar"
                  role="button"
                  onClick={handleBack}
                >
                  <Icon className="icon icon_left_app" />
                </a>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 pt-2">
              <h1 className="h1 login-title color-brand-1 txt-font-body mb-1">
                Por favor, confirme seu e-mail de cadastro:
              </h1>
              <br />
              <h2 className="custon-outline login-title txt-title-3 color-brand-1 txt-font-body h3">
                <span className="txt-bold color-brand-1">{onboardingUser != null ? onboardingUser.email : ''}</span>
              </h2>
            </div>
            <div className="hr mt-2" />
            <div className="col-12 pt-2">
                <div className="row">
                <Input
                    value={email}
                    label="E-Mail"
                    id="email"
                    className="col-12 col-md-12 mt-2"
                    onKeyUp={debounce}
                    onChange={handleChange}
                    type="email"
                    name="email"
                    valid={email == '' ? undefined : isValidConfirmEmail}
                    data-error={'Os emails não conferem.'}
                />
                </div>
            </div>
            {
              isLoading ? 
              (
                <div>
                  <p className='txt-body-sm color-ui-2 txt-font-body ml-1 mt-1'>Um momento enquanto validamos seu email...</p>
                </div>
              ) : ''
            }
            <div className="col-12 col-md-12 txt-center mt-2">
              <Button
                className="btn btn-sm btn-secondary btn-continue"
                text="Continuar"
                type="button"
                loading={isLoading}
                disabled={!isValidConfirmEmail}
                onClick={() => handleContinueEmailConfirmAndFocus(handleContinueEmailConfirm)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

EmailBox.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleContinueTemporary: PropTypes.func.isRequired,
  handleValidateConfirmEmail: PropTypes.func.isRequired,
  isValidConfirmEmail: PropTypes.bool,
  temporaryPassword: PropTypes.string,
  isHidden: PropTypes.bool,
  email: PropTypes.string,
  error: PropTypes.object
}

export default withRouter(EmailBox)
